import React from 'react';
import JobsContainer from '../../../Containers/AdminContainer/Jobs';

const JobsScreen = () => {
  return <JobsContainer />;
};

export default JobsScreen;
